module.exports = __webpack_public_path__ + "static/img/9b.3bdc2ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/9b.jpg
// module id = DAja
// module chunks = 0